
import React, { useEffect, useState } from 'react';
import Dropdown from '../../../DropDown/Dropdown';
import './patientmedical.css'
import { DatePicker, Input, InputNumber } from 'antd';
import moment from 'moment'

import { Radio } from 'antd';
import { l2navoptions } from '../../../../Helpers/InterBranchConstants';
import MedicalHistoryRoutes from '../../../../Routes/InterbranchRoutes/MedicalHistoryRoutes';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';


function PatientMedicalComponent() {

  let history = useHistory()
  let { path, url } = useRouteMatch();
  const { pathname } = useLocation();

  let [activeTop, setActiveTop] = useState(l2navoptions[0])


  useEffect(() => {
    
    history.push(`${url}/patientvitals`)

  }, [])
  

  let validateNumber = (event) => {

    if (event.which === 46 || event.which === 8) {
      //do nothing
    }
    else if (event.which < 48 || event.which > 57) {
      event.preventDefault();
    }
    else if (event.target.value.length > 9) {

      event.preventDefault();
    }

  }

  let getActiveOption = () => {

    let component = l2navoptions.filter(element => element.name === activeTop.name)[0].component

    if (component) {
      return React.cloneElement(component, { setActiveTop });
    }

  }

  let handleClick = (element) => {
    setActiveTop(element)
    history.push(`${path}/${element.target}`)
  }


  return (
    <div className='patient-medical-container'>

      <div className="header">
        <div className="l2-nav">
          <ul>
            {
              l2navoptions.map((element, key) => {
                return (
                  <>
                    <li
                      key={key}
                      className={pathname.includes(element.target) ? "active-element" : null}
                      onClick={() => { handleClick(element) }}
                    >
                      {element.name}
                    </li>{key < l2navoptions.length - 1 ? " | " : null}
                  </>
                )
              })
            }
          </ul>
        </div>
      </div>

      {/* {getActiveOption()} */}
      <MedicalHistoryRoutes setActiveTop={setActiveTop} />




    </div>
  );
}

export default PatientMedicalComponent;
